export default {
  'PUSH.COMMON.LANG.AFTER': '(default)',
  'PUSH.COMMON.CONFIRM.INPUT': 'Confirm here',
  'PUSH.COMMON.CONFIRM': 'CONFIRM',
  'PUSH.COMMON.APPROVE': 'APPROVE',
  'PUSH.COMMON.REJECT': 'REJECT',
  // 推送实验
  'PUSH.EXPERIMENT.TITLE': 'Push experiments',
  'PUSH.EXPERIMENT.ARCHIVED': 'Show archived experiments',
  'PUSH.EXPERIMENT.CREATE': 'New experiment',
  'PUSH.EXPERIMENT.CREATE_FAILED':
    'Cannot create a new experiment while there are experiments ongoing or pending approval',
  'PUSH.EXPERIMENT.ID': 'ID',
  'PUSH.EXPERIMENT.NAME': 'Name',
  'PUSH.EXPERIMENT.STATUS': 'Scheduled pushes',
  'PUSH.EXPERIMENT.USER_COUNT': 'Eligible players',
  'PUSH.EXPERIMENT.PUSHED_USER_COUNT': 'Pushes sent',
  'PUSH.EXPERIMENT.STATUS_LABEL': 'Status',
  'PUSH.EXPERIMENT.EXP_PUSH_START_TIME': 'Start time',
  'PUSH.EXPERIMENT.APPLICANT': 'Submitted by',
  'PUSH.EXPERIMENT.APPROVER': 'Reviewed by',
  'PUSH.EXPERIMENT.ACTIONS': 'Action',
  'PUSH.EXPERIMENT.STOPPED_STATUS': 'Terminated',
  'PUSH.EXPERIMENT.COMPLETED_STATUS': 'Completed',
  'PUSH.EXPERIMENT.TIMEOUT_STATUS': 'Approval overdue',
  'PUSH.EXPERIMENT.WAITING_STATUS': 'Pending',
  'PUSH.EXPERIMENT.PUSHING_STATUS': 'Sending',
  'PUSH.EXPERIMENT.REJECTED_STATUS': 'Submission rejected',
  'PUSH.EXPERIMENT.SEGMENT_TIMEOUT_STATUS':
    'Aborted (eligbility not yet confirmed)',
  'PUSH.EXPERIMENT.DRAFT_STATUS': 'Draft',
  'PUSH.EXPERIMENT.CONFIG_DETAIL': 'Config Details',
  'PUSH.EXPERIMENT.EDIT': 'Edit',
  'PUSH.EXPERIMENT.CREATE.HEADER_EDIT': 'Edit Push Experiment',
  'PUSH.EXPERIMENT.CREATE.HEADER_VIEW': 'Experiment Config Details',
  'PUSH.EXPERIMENT.CREATE.CONFIG_LOADING': 'Loading experiment config...',
  'PUSH.EXPERIMENT.CREATE.CONFIG_LOAD_FAILED':
    'Failed to load experiment config. Please retry later or go back to the list.',
  'PUSH.EXPERIMENT.CREATE.BACK_TO_LIST': 'Back to experiment list',
  'PUSH.EXPERIMENT.CREATE.CONTENT.EMPTY_HINT': 'No content in this config',
  'PUSH.EXPERIMENT.STOP': 'Terminate experiment',
  'PUSH.EXPERIMENT.STOP_CONFIRMATION':
    'Are you sure you want to terminate this experiment? After teminating, this experiment cannot be resumed.',
  'PUSH.EXPERIMENT.CONFIG': 'Upload push setup',
  'PUSH.EXPERIMENT.DOWNLOAD.CONFIG': 'Download setup',
  'PUSH.CREATE': 'New experiment',
  'PUSH.BASE_INFO': 'Basic info',
  'PUSH.BUSINESS_SELECT': 'Basic info',
  'PUSH.USER_COUNT.TITLE': 'Eligible players: ',
  'PUSH.USER_COUNT.DESCRIPTION':
    '(this is an estimate, actual number will be calculated again upon approval)',
  'PUSH.FILE_CHECK_PASS': 'File validated',
  'PUSH.CONFIG_PREVIEW': 'Preview',
  'PUSH.EXP_PUSH_START_TIME': 'Start',
  'PUSH.EXP_PUSH_END_TIME': 'End',
  'PUSH.GROUP_NAME': 'Group',
  'PUSH.TITLE_NAME': 'Title',
  'PUSH.BODY_NAME': 'Body',
  'PUSH.PUSH_ID': 'Push ID',
  'PUSH.SENDING_TIME': 'Time',
  'PUSH.TTL_NAME': 'Firebase TTL',
  'PUSH.SUBMIT_APPLICATION': 'Submit for approval',
  'PUSH.SUBMIT_APPLICATION_TIP':
    'After confirmation, all default push notifications will be paused for all players and the updated push notifications setup will be executed. Please proceed with caution.',
  'PUSH.EXPERIMENT.CONFIG_CHECK_FAIL':
    'Failed to validate experiment configuration',
  'PUSH.EXPERIMENT.OTHER_ERROR': 'Other error',

  // 默认推送
  'PUSH.DEFAULT.TITLE': 'Standard push',
  'PUSH.DEFAULT.ACTIVE_CONFIG': 'Message details',
  'PUSH.DEFAULT.APPROVAL_CONFIG_PREVIEW': 'Approval details',
  'PUSH.DEFAULT.HANDLE.CONFIG': 'Edit',
  'PUSH.DEFAULT.HANDLE.APPROVAL': 'Standard push pending approval',
  'PUSH.DEFAULT.ACTIVE_STATUS': 'Active',
  'PUSH.DEFAULT.PAUSE_STATUS': 'Terminated',
  // 默认推送：更改默认推送配置弹窗
  'PUSH.DEFAULT.EDIT.CONFIG.TITLE': 'Edit standard push',
  'PUSH.DEFAULT.HANDLE.INIT_STRATEGY': 'Initial setup',
  'PUSH.DEFAULT.HANDLE.CONFIG_TIPS':
    'After publishing, the new settings will be applied to all existing contacts. Proceed with caution.',
  'PUSH.DEFAULT.HANDLE.CONFIG_LABEL': 'Select setup',
  'PUSH.DEFAULT.HANDLE.SELECT_CONFIG': 'Select a setup',
  'PUSH.DEFAULT.HANDLE.SEARCH': 'Search',
  'PUSH.DEFAULT.HANDLE.SELECT_CONFIG.PREVIEW': 'Setup preview',
  'PUSH.DEFAULT.HANDLE.PUSH_ID': 'Push ID',
  // 默认推送：暂停、重启默认推送
  'PUSH.DEFAULT.HANDLE.PAUSE_PUSH': 'Pause',
  'PUSH.DEFAULT.HANDLE.RESTART_PUSH': 'Resume',
  'PUSH.DEFAULT.MODAL.PAUSE_PUSH': 'Pause default messages',
  'PUSH.DEFAULT.MODAL.RESTART_PUSH': 'Resume default messages',
  'PUSH.DEFAULT.STOP.TIPS.1':
    'After confirmation, <b class="color-333">default push notifications will be paused for all players starting from the next scheduled notification</b>. Please proceed with caution.',
  'PUSH.DEFAULT.STOP.TIPS.2':
    'After confirmation, <b class="color-333"> default push notifications will resume for all players from the next scheduled notification</b>. Please proceed with caution.',
  'PUSH.DEFAULT.NO_OPERABLE_CONFIG': 'No standard push currently active',
  // 默认推送：变更记录
  'PUSH.DEFAULT.DESCRIPTION': 'Changelog',
  'PUSH.DEFAULT.CONFIRM': 'Standard push changelog',
  'PUSH.DEFAULT.ACTION_TIME': 'Time',
  'PUSH.DEFAULT.ACTION_TYPE': 'Type',
  'PUSH.DEFAULT.ACTION_CONTENT': 'Description',
  'PUSH.DEFAULT.ACTION_USER': 'Performed by',
  'PUSH.DEFAULT.PUSH_STATUS': 'Paused/resumed',
  'PUSH.DEFAULT.CONFIG_APPROVAL': 'Setup review',
  'PUSH.DEFAULT.PAUSE_PUSH': 'Pause push',
  'PUSH.DEFAULT.RESTART_PUSH': 'Resume push',
  'PUSH.DEFAULT.APPROVED_DESCRIPTION': 'Approved: ',
  'PUSH.DEFAULT.REJECTED_DESCRIPTION': 'Submission rejected: ',
  'PUSH.DEFAULT.CONFIG.UPDATED': 'Setup updated to',
  'PUSH.DEFAULT.CONFIG_OPERATION': 'Setup is incomplete',
  'PUSH.DEFALUE.CONFIG_UPDAYED': 'Setup adjustment request',
  'PUSH.DEFAULT.DOWNLOAD_CONFIG_FAIL':
    'Failed to download configuration info: data is empty',
  'PUSH.DEFAULT.DOWNLOAD': 'Downloading configuration {name}',
  // 默认推送：列表
  'PUSH.DEFAULT.PUSH_STATUS_NAME': 'Name',
  'PUSH.DEFAULT.PUSH_STATUS_LABEL': 'Status',
  'PUSH.DEFAULT.PUSH_INFO_LABEL': 'Message details',
  'PUSH.DEFAULT.APPROVAL_DETAIL_LABEL': 'Approval details',
  'PUSH.DEFAULT.PUSH_TIME_LABEL': 'Local send time',
  'PUSH.DEFAULT.PUSH_ID': 'Push ID (push_id)',
  // 默认推送：审批列表
  'PUSH.DEFAULT.APPLIED_BY': 'Submitted by:',
  'PUSH.DEFAULT.SUBMITTED_AT': 'Submitted at:',
  'PUSH.DEFAULT.WIHTDRAW_SUB': 'Withdraw submission',
  'PUSH.DEFAULT.WIHTDRAW_CONFIRM':
    "Are you sure you want to withdraw this submission? Once withdrawn, you'll need to create a new submission.",
  'PUSH.DEFAULT.WIHTDRAW_SUCCESS': 'Submission withdrawn',

  // 待审核
  // 待审核：列表
  'PUSH.APPROVAL.TITLE.NAME': 'Pending approval',
  'PUSH.APPROVAL.DESCRIPTION':
    '<b class="color-333">Rules for approvals: </b>Any <b class="color-333">member</b> in the project other than the submitter can approve; the submitter cannot approve their own request.',
  'PUSH.APPROVAL.TYPE': 'Type',
  'PUSH.APPROVAL.EXPERIMENT_TYPE': 'Experiments',
  'PUSH.APPROVAL.NAME': 'Name',
  'PUSH.APPROVAL.CREATED_BY': 'Created by',
  'PUSH.APPROVAL.APPLIED_TIME': 'Submitted at',
  'PUSH.APPROVAL.APPROVE': 'Review',
  'PUSH.APPROVAL.APPLIER_CANNOT_APPROVE':
    'Submitter cannot approve their own request',
  // 待审核：去审批弹窗
  'PUSH.APPROVAL.RULE': 'Requirement for approvals',
  'PUSH.APPROVAL.WAIT_TIME':
    'Approval can only be completed after waiting <b style="color: #1F99DE">{num} seconds</b> on this page. It is important to review all details before giving your approval.',
  'PUSH.APPROVAL.APPLICATION_INFO': 'Submission details',
  'PUSH.APPROVAL.APPLICATION_TYPE': 'Type',
  'PUSH.APPROVAL.EXPERIMENT_NAME': 'Name',
  'PUSH.APPROVAL.EXP_PUSH_START_TIME': 'Start',
  'PUSH.APPROVAL.EXP_PUSH_END_TIME': 'End',
  'PUSH.APPROVAL.USER_COUNT': 'Eligible players',
  'PUSH.APPROVAL.APPLICANT': 'Submitted by',
  'PUSH.APPROVAL.APPLICATION_TIME': 'Submitted at',
  'PUSH.APPROVAL.CONFIG_DETAIL': 'Setup details',
  'PUSH.APPROVAL.DAY': 'Day',
  'PUSH.APPROVAL.PUSH_TIME': 'Time',
  'PUSH.APPROVAL.PUSH_ID': 'Push ID',
  'PUSH.APPROVAL.TITLE': 'Title',
  'PUSH.APPROVAL.BODY': 'Body',
  'PUSH.APPROVAL.TTL_NAME': 'Firebase TTL',
  'PUSH.APPROVAL.APPROVED': 'Approve',
  'PUSH.APPROVAL.REJECTED': 'Reject',
  'PUSH.APPROVAL.WAITING': 'Can be approved in {num} seconds.',
  // 待审核：审核通过 & 审核驳回弹窗
  'PUSH.APPROVAL.APPROVED_DESCRIPTION': 'Approval request',
  'PUSH.APPROVAL.APPROVED_CONFIRMATION':
    'After approving, this setup will be executed immediately.',
  'PUSH.APPROVAL.APPROVE.DESCRIPTION': 'Type <b>APPROVE</b> to confirm',
  'PUSH.APPROVAL.APPROVE.PLACEHOLDER':
    "To approve, enter <b>'APPROVE'</b> in uppercase letters.",
  'PUSH.APPROVAL.REJECTED.DESCRIPTION': 'Type <b>REJECT</b> to confirm',
  'PUSH.APPROVAL.REJECTED.PLACEHOLDER':
    "To reject, enter <b>'REJECT'</b> in uppercase letters.",
  // 待审核：审核驳回弹窗
  'PUSH.APPROVAL.REJECTED_DESCRIPTION': 'Reject',
  'PUSH.APPROVAL.REJECTED_CONFIRMATION':
    'After rejecting, this review procedure will be ended.',
  'PUSH.APPROVAL.CONFIG_REJECTED_DESCRIPTION':
    'The setup request has been rejected',
  'PUSH.APPROVAL.APPROVED_SUCCESS': 'Request approved',
  'PUSH.APPROVAL.REJECTED_SUCCESS': 'Request rejected',
  'PUSH.APPROVAL.ALREADY_APPROVED':
    'Approved by <b class="color-333">{accountName}</b> on <b class="color-333">{approvedTime}</b>',
  'PUSH.APPROVAL.APPLICATION_EXPIRED':
    'The approval deadline has expired. Please submit again.',
  // 待审核：审核详情弹窗
  'PUSH.APPROVAL.REJECTED_DETAIL': 'Approval details',
  'PUSH.APPROVAL.SUBMIT_FAILED_DESCRIPTION': 'Request declined',

  // 创建实验：提交发布申请弹窗
  'PUSH.APPROVAL.SUBMIT_APPLICATION_DESCRIPTION':
    'After the approval, <b>all eligible players</b> are instantly being added to the experiment group. The standard push will be paused while players are being allocated.',
  'PUSH.APPROVAL.DIVISION_COMPLETED': 'After allocation:',
  'PUSH.APPROVAL.STRATEGY_DESCRIPTION':
    '1.Players in experiment group: receive messages from experiment push.',
  'PUSH.APPROVAL.NOT_HIT_EXPERIMENT_PLAYER':
    '2.Players not in experiment group and new players: receive messages from standard push.',
  'PUSH.APPROVAL.USER_COUNT_DESCRIPTION':
    'The eligible player count is an estimate. The actual number will be calculated again upon approval.',
  'PUSH.APPROVAL.CONFIRM': 'CONFIRM',
  'PUSH.APPROVAL.SUBMIT_APPLICATION_SUCCESS': 'Submitted successfully',
  'PUSH.EXPERIMENT.APPROVAL.CONFIRM.DESCRIPTION':
    'Type <b>CONFIRM</b> to submit for approval',
  'PUSH.EXPERIMENT.APPROVAL.CONFIRM.PLACEHOLDER':
    "This experiment can only be submitted after typing in <b>'CONFIRM'</b> in uppercase letters.",

  // 实验
  // 'PUSH.EXPERIMENT.DOWNLOAD_CONFIG_FAILED': '下载配置信息失败：数据为空',
  // 'PUSH.EXPERIMENT.CONFIG_ERROR_FAILED': '配置文件存在错误，请修改后重新上传',
  // 'PUSH.EXPERIMENT.CONFIG_UPLOAD_FAILED': '请先上传配置文件',
  'PUSH.EXPERIMENT.BUSINESS_SELECT_FAILED': '',
  'PUSH.EXPERIMENT.BUSINESS_SELECT_THEN_UPLOAD': '',

  'PUSH.EXPERIMENT.ERROR.FILE_CONTENT_INVALID':
    'File content validation failed',
  'PUSH.EXPERIMENT.IMPORT.CSV.ERR.SIZE':
    'The uploaded file is too large. Only files under 1MB are supported for upload.',
  'PUSH.EXPERIMENT.ERROR.FILE_INVALID':
    'File format is not supported, please upload a new file.',
  'PUSH.EXPERIMENT.ERROR.NAME_DUPLICATE':
    'This experiment name already exists. Please use a new name.',
  'PUSH.EXPERIMENT.ERROR.CONFIG_RUNNING':
    'This experiment is already ongoing and cannot be submitted another time.',
  'PUSH.EXPERIMENT.ERROR.PAYLOAD_EXCEEDED':
    'The title and message have exceeded 2048 characters',
  'PUSH.EXPERIMENT.ERROR.DATA_EXCEEDED':
    'Total payload exceeds 4096 bytes, please reduce the data',
  'PUSH.EXPERIMENT.ERROR.INVALID_TIMEFRAME':
    'The time is too close or past the start time of the first message. Please select a new time.',
  'PUSH.EXPERIMENT.ERROR.MISSING_DEFAULT_LANG':
    'Default language is not configured, please specify default_lang in JSON',
  'PUSH.EXPERIMENT.ERROR.INVALID_DEFAULT_LANG_CODE':
    'The code for the default language is not supported, please refer to the language standards documentation',
  'PUSH.EXPERIMENT.ERROR.INVALID_OTHER_LANG_CODE':
    'The code for other languages are not supported, please refer to the language standards documentation',
  'PUSH.EXPERIMENT.ERROR.DUPLICATE_LANG': 'Duplicate languages',
  'PUSH.EXPERIMENT.ERROR.EMPTY_LANG_CONTENT':
    'The push message for this language is empty',

  'PUSH.EXPERIMENT.CREATE.ADD.EXPERIMENT.UPLOADED': 'File has been verified',
  'PUSH.EXPERIMENT.CREATE.ADD.EXPERIMENT.UPLOAD_FAILED': 'File upload failed',
  'PUSH.EXPERIMENT.CREATE.JSON.TIPS': 'Only supports JSON format',
  'PUSH.EXPERIMENT.FILE.UPLOAD.ERROR.MSG': 'File upload failed',
  'PUSH.EXPERIMENT.SUBMIT.SUCCEEDED': 'Submitted successfully',
  'PUSH.EXPERIMENT.DAY.PLACEHOLDER': 'Day {num}',
  'PUSH.EXPERIMENT.GROUP.PLACEHOLDER': 'Group {num}',
  'PUSH.EXPERIMENT.GROUP.TOOLTIP': 'Group id: {name}',

  // 创建实验流程：步骤标签（步骤1-4）
  'PUSH.EXPERIMENT.CREATE.STEP.1': 'Basic info',
  'PUSH.EXPERIMENT.CREATE.STEP.2': 'Language config',
  'PUSH.EXPERIMENT.CREATE.STEP.3': 'Push schedule',
  'PUSH.EXPERIMENT.CREATE.STEP.4': 'Push content',
  // 创建实验流程-步骤1 基础信息：页面大标题 / 副标题
  'PUSH.EXPERIMENT.CREATE.BASIC.TITLE': 'Experiment basic info',
  'PUSH.EXPERIMENT.CREATE.BASIC.DESC':
    'Enter the basic details to set up and manage this experiment.',
  // 创建实验流程-步骤1 基础信息：字段
  'PUSH.EXPERIMENT.CREATE.NAME.LABEL': 'Experiment name',
  'PUSH.EXPERIMENT.CREATE.NAME.PLACEHOLDER': 'Please enter the experiment name',
  'PUSH.EXPERIMENT.CREATE.NAME_EXISTS':
    'Push name already exists. Please use a different name.',
  'PUSH.EXPERIMENT.CREATE.START.LABEL': 'Start date',
  'PUSH.EXPERIMENT.CREATE.END.LABEL': 'End date',
  'PUSH.EXPERIMENT.CREATE.DATE.PLACEHOLDER': 'Select date',
  'PUSH.EXPERIMENT.CREATE.DATE.DESC': 'This period applies to all groups.',
  // 创建实验流程-步骤1 基础信息：底部按钮
  'PUSH.EXPERIMENT.CREATE.BUTTON.SAVE_DRAFT': 'Save draft',
  'PUSH.EXPERIMENT.CREATE.BUTTON.PREV': 'Previous',
  'PUSH.EXPERIMENT.CREATE.BUTTON.NEXT': 'Next',
  'PUSH.EXPERIMENT.CREATE.BUTTON.SUBMIT_APPROVAL': 'Submit for approval',
  'PUSH.EXPERIMENT.CREATE.BUTTON.SUBMIT_APPROVAL_SUCCESS': 'Submit successful',
  // Hover tip shown when "Next / Submit for approval" is disabled (shared by all steps)
  'PUSH.EXPERIMENT.CREATE.BUTTON.NEXT_DISABLED_TIP':
    'Please finish the configuration first, then continue.',
  // 创建实验流程-提交审批 / 保存草稿：结果与前置校验提示
  'PUSH.EXPERIMENT.CREATE.SAVE_DRAFT_SUCCESS': 'Draft saved successfully',
  'PUSH.EXPERIMENT.CREATE.LEAVE_CONFIRM_TITLE':
    'Are you sure you want to exit experiment creation?',
  'PUSH.EXPERIMENT.CREATE.LEAVE_NOT_SAVE': "Don't save draft",
  'PUSH.EXPERIMENT.CREATE.LEAVE_CONFIRM_DESC':
    'Changes will be lost if you leave without saving.',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_SUCCESS':
    'Submitted for approval, awaiting review',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_FAILED':
    'Submission failed. Please try again.',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_NEED_BASIC':
    'Please complete the basic info first: experiment name and push period are required, and the name must be unique.',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_NEED_LANG':
    'Please select a default language in the language configuration first.',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_NEED_CONTENT':
    'The following groups have no generated content yet, please complete them before submitting: {groups}',
  'PUSH.EXPERIMENT.CREATE.CHECK_PASSED':
    'Validation passed. Click "Submit application" in the top right to submit.',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_CONFIRM_TITLE': 'Confirm submission',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_CONFIRM_DESC':
    'The configuration will be validated before submission. After it passes, click "Submit application" in the top-right to publish. Continue?',
  'PUSH.EXPERIMENT.CREATE.CHECK_JSON_FAILED':
    'Config validation failed. Please review and try again.',
  'PUSH.EXPERIMENT.CREATE.SUBMIT_NEED_CHECK':
    'Please click "Submit for approval" in step 4 to validate the config before submitting the application.',
  // 提交审批 / 校验错误码文案（error_type 1001~1019，随界面语言切换）
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1001':
    'A push config with this name already exists. Please use a different name.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1002':
    'A push experiment is currently running. Please end or pause it first.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1003':
    'The scheduled start time is too early or invalid. Please set a future time.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1004':
    'The push config format is invalid. Please check the JSON content and try again.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1005':
    'The push experiment is missing test groups or group content. Please add at least one group with push content.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1006':
    'Some configuration fields are invalid. Please check the time settings and push ID.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1007':
    'The push title or body exceeds the length limit. Please shorten it.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1008':
    'The end time is invalid or earlier than the start time. Please adjust it.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1009':
    'The push payload is too large. Please reduce the content and try again.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1010':
    'This config has already been approved and cannot be edited. Please create a new version if changes are needed.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1011':
    'This config has been rejected. Please revise based on the feedback and resubmit.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1012':
    'This config has expired. Please update the valid time or create a new config.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1013':
    'The message TTL format is invalid. Please enter a valid value.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1014':
    'No default language is set. Please select a default language.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1015':
    'Some language codes are invalid. Please check and reselect.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1016':
    'Some language content is empty. Please fill in all required fields.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1017':
    'There are duplicate language settings. Please remove the duplicates.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1018':
    'The selected language is not configured in the system. Please add it first.',
  'PUSH.EXPERIMENT.CREATE.CHECK_ERR.1019':
    'The push time settings do not comply with the frequency control policy.',
  // 创建实验流程-步骤2 语言配置：页面副标题
  'PUSH.EXPERIMENT.CREATE.LANG.TITLE': 'Language configuration',
  'PUSH.EXPERIMENT.CREATE.LANG.DESC':
    'Select the default language for this experiment; recommended languages will be automatically pulled based on project audience.',
  // 创建实验流程-步骤2 语言配置：字段 / 统计 / 提示
  'PUSH.EXPERIMENT.CREATE.LANG.LABEL': 'Default language',
  'PUSH.EXPERIMENT.CREATE.LANG.COVERING_COUNT': 'Covering languages: {num}',
  // 覆盖语言数量（仅数字加粗）：前缀 + num + 后缀（英文无后缀）
  'PUSH.EXPERIMENT.CREATE.LANG.COVERING_COUNT_PREFIX': 'Covering languages: ',
  'PUSH.EXPERIMENT.CREATE.LANG.COVERING_COUNT_SUFFIX': '',
  // 已选语言数：覆盖语言（可取消） + 手动勾选的未覆盖语言，随选择实时变化
  'PUSH.EXPERIMENT.CREATE.LANG.SELECTED_COUNT': 'Selected language: {num}',
  'PUSH.EXPERIMENT.CREATE.LANG.PULLED_TIP':
    'Languages have been automatically pulled based on project audience.',
  'PUSH.EXPERIMENT.CREATE.LANG.UNKNOWN_TIP': 'Unknown ',
  'PUSH.EXPERIMENT.CREATE.LANG.DEFAULT_TAG': 'Default',
  'PUSH.EXPERIMENT.CREATE.LANG.ADDED_TAG': 'Added',
  'PUSH.EXPERIMENT.CREATE.LANG.VIEW_UNCOVERED':
    'View uncovered languages ({num})',
  // 创建实验流程-步骤3 分组与推送规划：页面大标题 / 副标题 / 状态
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.TITLE': 'Group & push schedule',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.DESC_PRE':
    'Group info has been automatically pulled from the ',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.DESC_POST':
    ' platform. Please complete the experiment period and push time planning for each group.',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.SYNCED': 'Group info synced',
  // 创建实验流程-步骤3 分组与推送规划：实验周期
  // Section title above the period options: {group} · push schedule
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.GROUP_TIME_TITLE': '{group} · push schedule',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.PERIOD': 'Experiment period',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.PERIOD_DAYS': '{num} days',
  // Unit label shown after the number in the custom period input
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.PERIOD_DAYS_UNIT': 'days',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.CUSTOM': 'Custom',
  // 创建实验流程-步骤3 分组与推送规划：推送时间点
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.PUSH_TIME': 'Push time point',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.MODE_SAME': 'Same time every day',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.MODE_DAILY': 'Daily config',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.DAILY_LABEL': 'Daily push time',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.DAY_N': 'Day {num}',
  // Daily config 每张卡片头部的当日推送次数（跟随已添加时间点数量变化；带分隔杠，与步骤4 预览行 "- X pushes" 风格一致）
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.DAY_PUSH_COUNT': '- {count} pushes',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ADD_TIME': 'Add time point',
  // Hint shown when all time points have been removed
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.EMPTY_TIME_TIP':
    'Please add time points; 3-4 recommended',
  // 创建实验流程-步骤3 分组与推送规划：应用到其他组
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.APPLY_BTN': 'Apply to other groups',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.APPLY_TITLE':
    "Apply current group's push schedule to",
  // Apply to other groups: description inside the dialog (targets "the groups below")
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.APPLY_DESC':
    "Copy the current group's experiment period and push times to the groups below",
  // Apply to other groups: hint beside the button (targets "other groups")
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.APPLY_OTHER_DESC':
    'Copy current group settings (cycle & push times) to other groups',
  // Apply to other groups: success toast
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.APPLY_SUCCESS': 'Applied successfully',
  // 创建实验流程-步骤3 分组与推送规划：说明
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ZONE_TITLE': 'Push time zone note',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ZONE_BODY':
    "All pushes are triggered automatically based on each player's device local time; no manual time-zone setup is required. For example, a push scheduled for 09:00 will arrive at 09:00 local time for users in Europe, North America and other regions.",
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ANTI_TITLE': 'Anti-disturbance strategy',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ANTI_BODY':
    'Push timing and frequency must meet the minimum-interval and frequency-cap requirements of the anti-disturbance strategy.',
  // 创建实验流程-步骤3 时间规划：防打扰策略校验弹窗
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ANTI_CHECK_TITLE':
    'Anti-disturbance strategy check',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ANTI_CHECK_LINE':
    'The push schedule for group "{group}" exceeds the push notification volume limit.',
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.ANTI_CHECK_FOOTER':
    'Please adjust and continue.',
  // 创建实验流程-步骤4 推送内容：页面大标题 / 副标题 / 配置方式
  'PUSH.EXPERIMENT.CREATE.CONTENT.TITLE': 'Push content',
  'PUSH.EXPERIMENT.CREATE.CONTENT.DESC':
    'Configure push copy. AI will generate titles and body text for the current group, or you can import existing content.',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CARD_TITLE': 'Push content config',
  'PUSH.EXPERIMENT.CREATE.CONTENT.GROUP_CARD_TITLE': '{group} · push content',
  'PUSH.EXPERIMENT.CREATE.CONTENT.SOURCE_AI': 'AI auto-generation',
  'PUSH.EXPERIMENT.CREATE.CONTENT.SOURCE_CSV': 'Import CSV',
  'PUSH.EXPERIMENT.CREATE.CONTENT.SOURCE_AI_TIP_DESC':
    'AI automatically generates titles and body based on your language style and push target description, and supports automatic translation into multiple languages.',
  'PUSH.EXPERIMENT.CREATE.CONTENT.SOURCE_CSV_TIP_DESC':
    'Upload a pre-prepared CSV file containing titles and body for each language version. Best for when you already have push content.',
  // 创建实验流程-步骤4 推送内容：推送目标描述
  'PUSH.EXPERIMENT.CREATE.CONTENT.BRIEF_LABEL': 'Push target description',
  'PUSH.EXPERIMENT.CREATE.CONTENT.BRIEF_PLACEHOLDER':
    'Briefly describe this push goal, e.g., re-engaging dormant players or promoting the new season.',
  'PUSH.EXPERIMENT.CREATE.CONTENT.BRIEF_MIN_LENGTH':
    'The description must be at least 5 characters.',
  // 创建实验流程-步骤4 推送内容：语言风格
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_LABEL': 'Language style',
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_INCENTIVE': 'Incentivizing',
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_GENTLE': 'Gentle',
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_RELAX': 'Casual',
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_INTIMATE': 'Intimate',
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_CUSTOM': 'Custom',
  'PUSH.EXPERIMENT.CREATE.CONTENT.STYLE_EMPTY': 'Not selected',
  // 创建实验流程-步骤4 推送内容：表情符号
  'PUSH.EXPERIMENT.CREATE.CONTENT.EMOJI_LABEL': 'Emoji usage',
  'PUSH.EXPERIMENT.CREATE.CONTENT.EMOJI_MUST_HAVE': 'Must include',
  'PUSH.EXPERIMENT.CREATE.CONTENT.EMOJI_MUST_NOT_HAVE': 'Do not include',
  'PUSH.EXPERIMENT.CREATE.CONTENT.EMOJI_CASUALLY': 'Optional',
  // 创建实验流程-步骤4 推送内容：生成按钮 / 过程状态
  'PUSH.EXPERIMENT.CREATE.CONTENT.GENERATE_BTN': 'Generate content',
  'PUSH.EXPERIMENT.CREATE.CONTENT.GENERATING':
    'Generating title and body text...',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PROGRESS_1': 'Selecting push content assets',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PROGRESS_2': 'Building push strategy',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PROGRESS_3':
    'Generating default-language content',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PROGRESS_4':
    'Generating multilingual content',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PROGRESS_5': 'Running content quality checks',
  'PUSH.EXPERIMENT.CREATE.CONTENT.RESULT_TIP_MAIN': 'Push content generated',
  'PUSH.EXPERIMENT.CREATE.CONTENT.RESULT_TIP_GROUP': ' · {group} ({num} items)',
  'PUSH.EXPERIMENT.CREATE.CONTENT.GENERATED_NOTIFY':
    'Push content generated for group "{group}" ({num} items)',
  'PUSH.EXPERIMENT.CREATE.CONTENT.REGENERATE': 'Regenerate',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CUSTOM_PLACEHOLDER':
    'Enter a custom language style, e.g., formal or playful',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_PARSE_FAIL':
    'File parse failed · {group}',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_HEADER':
    'The file header does not match the template. Please include the day, time, lang, title and body columns and upload again.',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_LENGTH':
    'The title or body in row {row} exceeds the limit (title: 65, body: 240). Please shorten the text and upload again.',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_EMPTY':
    'The content in row {row} is empty. Please add a title and body.',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_LANG':
    'The language code in row {row} is not supported. Please check the supported languages list.',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_TIME_PLAN_MISMATCH':
    "This file doesn't match the configured time plan. Please adjust the time plan or update the file first.",
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERROR_ROW_PREFIX': 'Row {row}: ',
  // 创建实验流程-步骤4 推送内容：CSV 上传区
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_UPLOAD_TITLE': 'Upload CSV file',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_FORMAT':
    'Only CSV or Excel files are supported. Your file is in {ext} format. Please convert it and upload again.',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_ERR_SIZE':
    'This file is too large (max {max}). Please reduce the content and upload again.',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_DRAG_TIP':
    'Choose a file or drag it here',
  'PUSH.EXPERIMENT.CREATE.CONTENT.CSV_FORMAT_HINT':
    'Supports CSV format with columns: id, title, time, image, body',
  // 创建实验流程-步骤4 推送内容：内容预览（AI 自动生成与 CSV 导入共用）
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_TITLE': 'Push content preview',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_EDIT_TIP':
    'Title and body can be edited',
  // Preview day group row: first part "Day {day}" bold, count part regular
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_DAY': 'Day {day}',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_DAY_COUNT': '- {count} pushes',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_COL_TIME': 'Time',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_COL_TITLE': 'Subject',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_COL_BODY': 'Content',
  'PUSH.EXPERIMENT.CREATE.CONTENT.PREVIEW_COL_PUSH_ID': 'Push id',

  'PUSH.EXPERIMENT.CREATE.GROUP_DONE': 'Configured',
  'PUSH.EXPERIMENT.CREATE.GROUP_NO_DONE': 'Unset',
  // 新增实验弹窗：手动创建（向导模式）卡片
  'PUSH.EXPERIMENT.CREATE.MANUAL.TITLE': 'Create manually',
  'PUSH.EXPERIMENT.CREATE.MANUAL.DESC':
    'Step-by-step setup with AI-generated push content',
  // 新增实验弹窗：导入 JSON 卡片
  'PUSH.EXPERIMENT.CREATE.JSON.TITLE': 'Create from JSON file',
  'PUSH.EXPERIMENT.CREATE.JSON.DESC':
    'If you have a complete JSON configuration, import it to quickly create an experiment.',
  // Step 3 time plan: the date span is shorter than the experiment period (cycle exceeds the push window) guard message
  'PUSH.EXPERIMENT.CREATE.TIMEPLAN.CYCLE_EXCEED_WINDOW':
    'The duration between the start and end time is shorter than the experiment period. Please extend the duration or adjust the period settings.',
};
